import React, { useState } from "react";
import { Form } from "react-bootstrap";
import Select from "react-select";
import { ErrorMessage } from "formik";

export default function EmergencyTabFields({
  values,
  handleChange,
  setFieldValue,
  emergencyRelation,
}) {
  const relationshipOpts = [
    { value: "mother", label: "Mother" },
    { value: "father", label: "Father" },
    { value: "grand-parent", label: "Grand Parent" },
    { value: "aunt", label: "Aunt" },
    { value: "uncle", label: "Uncle" },
    { value: "sibling", label: "Sibling" },
    { value: "babysitter-nanny", label: "BabySitter/Nanny" },
    { value: "other", label: "Other" },
  ];
  const isRelationEmpty = relationshipOpts.find(
    (obj) => obj.value === emergencyRelation
  );
  const [selectedRelation] = useState(
    isRelationEmpty
      ? { value: isRelationEmpty.value, label: isRelationEmpty.label }
      : null
  );

  return (
    <>
      <div className="d-flex flex-wrap">
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>First Name</Form.Label>
          <Form.Control
            type="text"
            name="emergencyFirstName"
            placeholder="Enter first name"
            value={values.emergencyFirstName}
            onChange={handleChange}
          />
          <ErrorMessage
            name="emergencyFirstName"
            component="p"
            className="error-message"
          />
        </div>
        <div className="mb-3 flex-grow-1">
          <Form.Label>Last Name</Form.Label>
          <Form.Control
            type="text"
            name="emergencyLastName"
            placeholder="Enter last name"
            value={values.emergencyLastName}
            onChange={handleChange}
          />
          <ErrorMessage
            name="emergencyLastName"
            component="p"
            className="error-message"
          />
        </div>
      </div>
      <div className="d-flex flex-wrap">
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>Phone Number</Form.Label>
          <Form.Control
            type="tel"
            name="emergencyPhone"
            placeholder="Enter phone number"
            value={values.emergencyPhone}
            onChange={handleChange}
          />
          <ErrorMessage
            name="emergencyPhone"
            component="p"
            className="error-message"
          />
        </div>
        <div className="mb-3 w-50">
          <Form.Label>Relationship with Child</Form.Label>
          <Select
            name="emergencyRelation"
            className="select-field"
            defaultValue={selectedRelation}
            isSearchable={false}
            options={relationshipOpts}
            onChange={(opt) => setFieldValue("emergencyRelation", opt.value)}
          />
          <ErrorMessage
            name="emergencyRelation"
            component="p"
            className="error-message"
          />
        </div>
      </div>
      <div className="d-flex flex-wrap">
        <div className="mb-3 flex-grow-1">
          <Form.Label>Street Address Line 1</Form.Label>
          <Form.Control
            type="text"
            name="emergencyAddress1"
            placeholder="Enter street address"
            value={values.emergencyAddress1}
            onChange={handleChange}
          />
          <ErrorMessage
            name="emergencyAddress1"
            component="p"
            className="error-message"
          />
        </div>
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>Street Address Line 2</Form.Label>
          <Form.Control
            type="text"
            name="emergencyAddress2"
            placeholder="Enter street address"
            value={values.emergencyAddress2}
            onChange={handleChange}
          />
          <ErrorMessage
            name="emergencyAddress2"
            component="p"
            className="error-message"
          />
        </div>
      </div>
      <div className="d-flex flex-wrap">
        <div className="mb-3 me-lg-3 me-0 flex-grow-1">
          <Form.Label>Postcode</Form.Label>
          <Form.Control
            type="text"
            name="emergencyPostcode"
            placeholder="Enter postcode"
            value={values.emergencyPostcode}
            onChange={handleChange}
          />
          <ErrorMessage
            name="emergencyPostcode"
            component="p"
            className="error-message"
          />
        </div>
        <div className="mb-3 flex-grow-1">
          <Form.Label>City</Form.Label>
          <Form.Control
            type="text"
            name="emergencyCity"
            placeholder="Enter city"
            value={values.emergencyCity}
            onChange={handleChange}
          />
          <ErrorMessage
            name="emergencyCity"
            component="p"
            className="error-message"
          />
        </div>
      </div>
    </>
  );
}
